import React, { useEffect, useState } from "react";
import { FcCancel } from "react-icons/fc";
import newContractAbi from "../Services/NewContractAbi.json";
import { ethers } from "ethers";
import { Spinner } from "flowbite-react";
import { useNetwork,useSigner,useAccount } from "wagmi";
const { BigNumber } = require("ethers");


const TransactionRejected = () => {
  //------------------USESTATES------------------------------------//
  const [recipent, setRecipent] = useState();
  const [amount, setAmount] = useState();
  const [loading, setLoading] = useState(true);
  const [viewTransaction,setViewTransaction] = useState();
  const [transtime, setTransTime] = useState();
  const [coin,setCoin] = useState();
  let date;
  

   //--------hooks from wagmi-------------------------//
   const { data: signer } = useSigner();
   const { chain } = useNetwork();
   const { address } = useAccount();

  //-----------------------Connecting with Contract-----------------------------//


  const contractAddress = localStorage.getItem("Contracttocancel");



  //----------------------USEEFFECT-----------------------------//
  useEffect(() => {
   
    if(signer)
    {
      cancelContractInfo();
    }
  }, [signer, chain]);




  //----------------------Cancel Trasaction-----------------------------//

  const cancelContractInfo = async () => {
   
   if(chain.id ===97)
   {
    
     setCoin("BNB");
    const newContract = new ethers.Contract(
      contractAddress,
      newContractAbi,
      signer
    );
   

    try{
      newContract?.smartContract().then(async (response) => {
        setRecipent(response.recipient
          );
        const wei = BigNumber.from(response.amount).toString()
        const ether = ethers.utils.formatEther(wei)
   
        setAmount(ether);
        const bigNumber = BigNumber.from(response.unlockTime);
        const timeInSeconds = bigNumber.toString(); // time in seconds from the contract
        date = new Date(); // create a new date object with the Unix epoch as the initial value
        date.setTime(timeInSeconds*1000);
        const time = date.toString(); // readeable time format
        setTransTime(time); //updating time variable
        // console.log("going dart:" + date);
  
        //     console.log("Time in unix time stamo",timeInSeconds)
        const hash = localStorage.getItem("cancelledhash");
        const link = "https://testnet.bscscan.com/tx/";
        const fullhash = link+hash;
         setViewTransaction(fullhash);
       
      
        setLoading(false);
      });
    } catch(error){ console.log("BSC TEST_NET",error)}

   }else{
   try{

    setCoin("ETH")
    const newContract = new ethers.Contract(
      contractAddress,
      newContractAbi,
      signer
    );
   

    newContract?.smartContract().then(async (response) => {
      setRecipent(response.recipient
        );
      const wei = BigNumber.from(response.amount).toString()
      const ether = ethers.utils.formatEther(wei)
      console.log("amount from response",ether);
      setAmount(ether);
      const bigNumber = BigNumber.from(response.unlockTime);
      const timeInSeconds = bigNumber.toString(); // time in seconds from the contract
      date = new Date(); // create a new date object with the Unix epoch as the initial value
      date.setTime(timeInSeconds*1000);
      const time = date.toString(); // readeable time format
      setTransTime(time); //updating time variable
      const hash = localStorage.getItem("cancelledhash");
      const link = "https://sepolia.etherscan.io/tx/";
      const fullhash = link+hash;
       setViewTransaction(fullhash);
     
    
      setLoading(false);
    });
   }catch(error){
     console.log("SEPOLIA TEST_NET",error)
   }

   }
  };
  console.log("receiver address from response",recipent);
  console.log("amount from response",amount);
  return (
    <div className=" h-screen flex items-center justify-center ">
      {loading?(<Spinner/>):(<div className="w-auto text-center tracking-widest p-4 pt-8  ml-2  bg-slate-50 shadow-lg h-fit  ">
        <h1 className=" text-3xl"> Cancelled</h1>
        <center className="mt-4">
          <FcCancel color="orange" size={140} />
        </center>
        <h1 className="text-2xl mt-4 "> {amount} {coin}</h1>
        {/* <p className="text-2xl mt-1">{amount}</p> */}
        <div className="md:flex justify-between text-xl mt-4 mb-2">
          <h1> To</h1>
          <p className=" text-sm tracking-normal"> {recipent}</p>
        </div>
        <hr className="border-dashed w-full bg-slate-500"></hr>
        <div className="flex justify-between text-xl mt-2 mb-2 ">
          <h1> Fee</h1>
          <p>0 </p>
        </div>
        <hr className="border-dashed w-full  bg-slate-500"></hr>
        <div className="flex justify-between gap-10 lg:gap-56 mt-2 mb-2">
          <h1> Date/Time</h1>
          <p> {transtime}</p>
        </div>
        <hr className="border-dashed w-full bg-slate-500"></hr>
        <div className="flex justify-between mt-2 mb-2 ">
          <h1> Transaction</h1>
          <a href={viewTransaction} className="text-blue-700 font-semibold">
            {" "}
            View Transactions
          </a>
        </div>
        <hr className="border-dashed w-full bg-slate-500"></hr>
        <div className="flex justify-between mt-2">
          <h1> Status</h1>
          <p className="bg-red-200 p-1 text-red-700"> CANCELLED </p>
        </div>
      </div>)}
    </div>
  );
};

export default TransactionRejected;
